import React from "react";
import { useSelector } from "react-redux";
import { getAllProductsIMG } from "../../../services/api";

function SearchResults() {
  const products = useSelector(
    (state) => state.products?.searchResults || []
  );

  if (!products.length) return null;

  return (
<div className="mt-2 w-full bg-white rounded-xl shadow-lg overflow-hidden max-h-96 overflow-y-auto rounded-md no-scrollbar">
  {products.map((item) => (
    <div
      key={item.id}
      className="flex items-center md:gap-3 px-1 py-2 md:px-4 md:py-3 border-b border-b-gray-200 last:border-b-0 cursor-pointer hover:bg-gray-50 transition"
    >
      <img
        src={`${getAllProductsIMG}/${item.product_image}`}
        alt={item.short_name}
        className="w-14 h-14 md:w-14 md:h-14 rounded-md object-contain position-center"
      />

      <div className="flex-1 min-w-0">
        <p className="text-sm md:font-semibold font-medium text-gray-800 truncate">
          {item.short_name}
        </p>

        <p className="text-xs text-gray-500 truncate">
          {item.long_description}
        </p>
      </div>
    </div>
  ))}
</div>
  );
}

export default SearchResults;